export const resources = {
  MediaFiles: '',
  LiveFeeds: '',
  AccountSettings: '',
  ModelCustomizations: '',
  OpenSideMenu: '',
  CloseSideMenu: ''
};
